export default __webpack_public_path__ + "static/media/mapper.16859123.svg";